import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ThemePreferenceMenuItems } from "@/components/shared/ThemePreferenceMenuItems";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ThemeSwitcher(): JSX.Element {
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="text-foreground"
        aria-label={t("theme.label")}
        disabled
      >
        <Sun className="h-5 w-5 opacity-50" aria-hidden />
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="relative text-foreground transition-colors duration-150 hover:bg-accent hover:text-accent-foreground"
          aria-label={t("theme.label")}
        >
          <Sun
            className="h-5 w-5 rotate-0 scale-100 transition-all duration-200 motion-reduce:transition-none dark:-rotate-90 dark:scale-0"
            aria-hidden
          />
          <Moon
            className="absolute h-5 w-5 rotate-90 scale-0 transition-all duration-200 motion-reduce:transition-none dark:rotate-0 dark:scale-100"
            aria-hidden
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <ThemePreferenceMenuItems />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
